<template>
  <PhoneCallsTab
    v-if="currentUser"
    :linked-calls="linkedCalls"
    :filters="filters"
    linkable-type="User"
    :linkable-id="currentUser.id"
    @link-call="handleLinkCall"
  />
</template>

<script>
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import PhoneCallsTab from "@/CallComponents/PhoneCallsTab.vue";

export default {
  components: {
    PhoneCallsTab
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      currentUser: "currentUser",
      linkedCalls({ currentUser }) {
        if (!currentUser) {
          return [];
        }
        return currentUser.linked_calls;
      }
    })
  },
  mounted() {
    EventBus.$on("refresh-linked-calls", this.reloadUser);
  },
  beforeUnmount() {
    EventBus.$off("refresh-linked-calls", this.reloadUser);
  },
  methods: {
    ...mapActions(["linkCall", "fetchUser"]),
    handleLinkCall(callId) {
      const { links } = this.currentUser;
      if (links.link_call) {
        this.linkCall({ link: links.link_call, call_id: callId }).then(() => {
          window.notify.success(
            "Phone call was succesfully linked to customer."
          );
          this.reloadUser();
          EventBus.$emit("refresh-datatable");
        });
      }
    },
    reloadUser() {
      this.fetchUser({ id: this.currentUser.id });
    }
  }
};
</script>

<style lang="scss" scoped></style>
